export default "__VITE_ASSET__a7fcc2d3__"